/** Nota média no formato brasileiro, sempre com uma casa: 4,8 · 5,0. */
export const formatRating = (average: number) => average.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
